import { useCallback, useState } from "react";

const clampWidth = ({ value, minWidth, maxWidth }) =>
  Math.min(maxWidth, Math.max(minWidth, Math.round(value)));

export const useResizableSidebarWidth = ({
  defaultWidth,
  minWidth,
  maxWidth,
}) => {
  const [width, setWidth] = useState(() =>
    clampWidth({ value: defaultWidth, minWidth, maxWidth })
  );

  const onResizePointerDown = useCallback(
    (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      event.preventDefault();
      event.stopPropagation();
      const originX = event.clientX;
      const originWidth = width;
      const pointerId = event.pointerId;
      const target = event.currentTarget;
      target.setPointerCapture?.(pointerId);

      const onMove = (moveEvent) => {
        const next = originWidth + (moveEvent.clientX - originX);
        setWidth(clampWidth({ value: next, minWidth, maxWidth }));
      };
      const onUp = () => {
        target.releasePointerCapture?.(pointerId);
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
      };
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onUp);
    },
    [maxWidth, minWidth, width]
  );

  return { width, setWidth, onResizePointerDown };
};

export const sidebarResizeHandleSx = {
  position: "absolute",
  top: 0,
  right: 0,
  width: 8,
  height: "100%",
  cursor: "col-resize",
  zIndex: 3,
  touchAction: "none",
  "&:hover": {
    bgcolor: "rgba(17, 24, 39, 0.08)",
  },
};
